import * as types from './types'
import storage from '@/plugins/storage'
const apiUrl = window.config ? window.config.apiUrl : ''

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.TESTDRIVE_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.TESTDRIVE_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.TESTDRIVE_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.TESTDRIVE_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.TESTDRIVE_FILTER_BY, filterBy)
  },
  [types.INIT_TESTDRIVE](state) {
    state.highlightSave = false
    state.testdrive = JSON.parse(JSON.stringify(state.default))
  },
  [types.INIT_TESTDRIVEDRIVE](state) {
    state.highlightSave = false
    state.testdrivedrive = JSON.parse(JSON.stringify(state.defaultDrive))
  },
  [types.INIT_TESTDRIVEWAYPOINT](state) {
    state.highlightSave = false
    state.testdrivewaypoint = JSON.parse(JSON.stringify(state.defaultWaypoint))
  },
  [types.SET_TESTDRIVE](state, data) {
    state.testdrive = data
  },
  [types.SET_TESTDRIVETYPERATES](state, data) {
    state.testdriveTypeRates = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveTypeRates = data
      }
    }
  },
  [types.SET_TESTDRIVES](state, data) {
    state.testdrives = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdrives = data
      }
    }
  },
  [types.UPDATE_TESTDRIVE](state, data) {
    if (state.testdrive !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.testdrive.firm = parseInt(data.value)
          state.testdrive.vehicle.firm = parseInt(data.value)
          break
        case 'contact':
          state.testdrive.contact = parseInt(data.value)
          state.testdrive.vehicle.contact = parseInt(data.value)
          break
        case 'testdriveType':
          state.testdrive.testdriveType = parseInt(data.value)
          break
        case 'insurance':
          state.testdrive.insurance = parseInt(data.value)
          break
        case 'fleetContact':
          state.testdrive.fleetContact = parseInt(data.value)
          break
        case 'ronumber':
          state.testdrive.ronumber = data.value
          break
        case 'invoiceNumber':
          state.testdrive.invoiceNumber = data.value
          break
        case 'fleetNumber':
          state.testdrive.fleetNumber = data.value
          break
        case 'vehicleYear':
          state.testdrive.vehicle.year = data.value
          break
        case 'vehicleMake':
          state.testdrive.vehicle.make = data.value
          break
        case 'vehicleModel':
          state.testdrive.vehicle.model = data.value
          break
        case 'vehicleVin':
          state.testdrive.vehicle.vin = data.value
          break
        case 'createdBy':
          state.testdrive.createdBy = data.value
          break
        case 'notes':
          state.testdrive.notes = data.value
          break
        case 'status':
          console.log('Updating Status', data)
          state.testdrive.status = parseInt(data.value)
          break
      }
    }
  },
  [types.SET_TESTDRIVEDRIVES](state, data) {
    state.testdrivedrives = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdrivedrives = data
      }
    }
  },
  [types.SET_TESTDRIVEDRIVE](state, data) {
    console.log('Setting Test Drive Drive', data)
    state.testdrivedrive = data
  },
  [types.UPDATE_TESTDRIVEDRIVE](state, data) {
    if (state.testdrivedrive !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.testdrivedrive.firm = parseInt(data.value)
          break
        case 'testdrive':
          state.testdrivedrive.testDrive = parseInt(data.value)
          break
        case 'driveName':
          state.testdrivedrive.driveName = data.value
          break
        case 'driveType':
          state.testdrivedrive.driveType = parseInt(data.value)
          break
        case 'techs':
          state.testdrivedrive.techs = []
          for (let i = 0; i < data.value.length; i++) {
            state.testdrivedrive.techs.push({
              id: data.value[i].id,
              name: data.value[i].name
            })
          }
          break
        case 'speedMin':
          state.testdrivedrive.speedMin = parseFloat(data.value)
          break
        case 'speedMax':
          state.testdrivedrive.speedMax = parseFloat(data.value)
          break
        case 'driveStart':
          state.testdrivedrive.driveStart = data.value
          break
        case 'driveEnd':
          state.testdrivedrive.driveEnd = data.value
          break
        case 'distanceStart':
          state.testdrivedrive.distanceStart = parseFloat(data.value)
          break
        case 'distanceEnd':
          state.testdrivedrive.distanceEnd = parseFloat(data.value)
          break
        case 'weather':
          state.testdrivedrive.weather = data.value
          break
        case 'notes':
          state.testdrivedrive.notes = data.value
          break
        case 'technicianContact':
          state.testdrivedrive.technicianContact = parseInt(data.value)
          break
        case 'videoUrl':
          state.testdrivedrive.videoUrl = data.value
          break
      }
    }
  },
  [types.SET_TESTDRIVEWAYPOINTS](state, data) {
    state.testdrivewaypoints = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdrivewaypoints = data
      }
    }
  },
  [types.SET_TESTDRIVEWAYPOINT](state, data) {
    state.testdrivewaypoint = data
  },
  [types.UPDATE_TESTDRIVEWAYPOINT](state, data) {
    if (state.testdrivedrive !== null && data !== null) {
      switch (data.name) {
        case 'testdrive':
          state.testdrivewaypoint.testdrive = parseInt(data.value)
          break
        case 'testdrivedrive':
          state.testdrivewaypoint.testdrivedrive = parseInt(data.value)
          break
        case 'latitude':
          state.testdrivewaypoint.latitude = parseFloat(data.value)
          break
        case 'longitude':
          state.testdrivewaypoint.longitude = parseFloat(data.value)
          break
        case 'time':
          state.testdrivewaypoint.time = data.value
          break
        case 'speed':
          state.testdrivewaypoint.speed = parseFloat(data.value)
          break
      }
    }
  },
  [types.SET_VIDEO_URL](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdrivedrive.videoUrl = `${apiUrl}/${data}`
      }
    }
  },
  [types.SET_WEATHER](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.weather = data
      }
    }
  },
  [types.SET_VIDEOLINK](state, data) {
    state.videolink = null
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.videolink = data
      }
    }
  },
  [types.SET_TESTDRIVERESULTS](state, data) {
    state.testdriveResults = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResults = data
      }
    }
  },
  [types.SET_REPORTPREFERENCE](state, data) {
    state.reportPreference = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrives/mutations.js